import { render, staticRenderFns } from "./WarnAlert.vue?vue&type=template&id=48c32f22&"
import script from "./WarnAlert.vue?vue&type=script&lang=js&"
export * from "./WarnAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports